module.exports = __webpack_public_path__ + "img/loyalty.7e3ffc8a.svg";